import { useEffect, useState } from "react";
import usePublicClient from "@/hooks/usePublicClient";
import { usdcInfo } from "@/constants/tokens";
import { TokenInfo, useUserInfo } from "@/context/UserInfo";
import {
  accMul,
  formatAmount,
  parseAmount,
  toFixed,
} from "@/utils/formatBalance";

export const useNetworkFee = ({ token }: { token: TokenInfo | null }) => {
  const publicClient = usePublicClient();
  const { ethPrice } = useUserInfo();

  const [networkFeeAmount, setNetworkFeeAmount] = useState("0");
  const [networkFeeValue, setNetworkFeeValue] = useState("0");

  const getNetworkFee = async () => {
    if (!token || !ethPrice) {
      setNetworkFeeAmount("0");
      setNetworkFeeValue("0");
      return;
    }

    // 如果是 USDC，gas fee 为 0
    if (token.address === usdcInfo.address) {
      setNetworkFeeAmount("0");
      setNetworkFeeValue("0");
      return;
    }

    try {
      const gasPrice = await publicClient.getGasPrice();
      const estimatedFee = (gasPrice * 600000n).toString();
      setNetworkFeeAmount(estimatedFee);
      setNetworkFeeValue(
        parseAmount(
          toFixed(
            accMul(formatAmount(estimatedFee, 18), ethPrice),
            usdcInfo.decimals
          ),
          usdcInfo.decimals
        )
      );
    } catch (error) {
      console.error("获取 gas fee 失败:", error);
      setNetworkFeeAmount("0");
      setNetworkFeeValue("0");
    }
  };

  useEffect(() => {
    getNetworkFee();
  }, [token, ethPrice]);

  return {
    networkFeeAmount,
    networkFeeValue,
  };
};
